import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ScrollToTopBadge from '../../component/ScrollToTop';
import { IAuftragLieferung } from '../../types/Types';
import { useGetLieferungenListeMutation } from '../../api/AuftragAPI';

/**
 * @author noone
 */
export type ThisProps = {
  //statusChanged: () => void;
}

export default function AGLieferungenListe(props: ThisProps) {

  const { t } = useTranslation();

  const [getLieferungenListeAPI] = useGetLieferungenListeMutation();

  const [liste, setListe] = useState<IAuftragLieferung[]>([]);

  const lade = () => {
    getLieferungenListeAPI().unwrap()
      .then(setListe)
      .catch((error) => console.log(error))
      ;

  }

  useEffect(() => {
    window.scrollTo(0, 0);

    lade();
  }, []);

  return (

    <div>

      <h3>Lieferungen</h3>

      <ScrollToTopBadge />


      <table className="table table-striped">
        <thead>
          <tr>
            <th>Lieferant</th>
            <th>Jahr</th>
            <th>KW</th>
          </tr>
        </thead>
        <tbody>
          {
            liste?.slice().map((e, index) => (
              <tr key={e.uid} >
                <td style={{ padding: "12px 16px" }}>{e.lieferant}</td>
                <td style={{ padding: "12px 16px" }}>{e.jahr}</td>
                <td style={{ padding: "12px 16px" }}>{e.kw}</td>
              </tr>
            ))
          }
        </tbody >
      </table >

      <ScrollToTopBadge />

    </div >
  );

}
function getAuftragMessagesListe(): [any] {
  throw new Error('Function not implemented.');
}

